export async function downloadVideoBlobUrl(
  src: string,
  filename: string,
): Promise<void> {
  try {
    const response = await fetch(src, {
      credentials: "same-origin",
    });

    if (!response.ok) {
      console.error(`Failed to fetch video: ${response.statusText}`);
      return;
    }

    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(blobUrl);
    }, 0);
  } catch (e) {
    console.error("[downloadVideoBlobUrl]", e);
  }
}
